// extracted by mini-css-extract-plugin
module.exports = {"root":"PokeCard_root__3-gz_","header":"PokeCard_header__3iztZ","addButton":"PokeCard_addButton__2GBUN","body":"PokeCard_body__1_xzZ","footer":"PokeCard_footer__2MUAA"};